const COLORS = {
    primaryColor: '#006CB0',
    secondaryColor: '#CDCDCD',
}

export default COLORS;